module.exports = __webpack_public_path__ + "static/img/file_dmg.a0f37ffd.png";